import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Varun Papishetty </span>
            from <span className="purple"> USA.</span>
            <br />
            I am currently Pursuing my Master's in Software Engineering at San Jose State University.
            <br />
            I Worked as an Associate Software Engineer about a year at Infor.
            .
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Movies
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Keep smiling because it suits everyone."{" "}
          </p>
          <footer className="blockquote-footer">Varun</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
